import { usePathname, useSegments } from 'expo-router';
import { Platform, StyleSheet, View, useWindowDimensions } from 'react-native';
import { useColor } from '@/hooks/useColor';

import Text from './Text';

interface TitleProps {
  label: string;
  colorVariant?: 'default' | 'alt';
  fontWeight?: '450' | '500' | '600' | '700' | '900';
}

const Title = ({ label, colorVariant = 'default', fontWeight = '700' }: TitleProps) => {
  const { width } = useWindowDimensions();
  const colors = useColor();
  const pathname = usePathname();
  const segments = useSegments();

  const getMarginLeft = (): number => {
    if (Platform.OS === 'web' || Platform.OS === 'ios') return 0;

    const last = segments.at(-1);
    const prev = segments.at(-2);
    const thirdLast = segments.at(-3);

    if (prev === 'profile' && last === 'individual') return -44;
    if (thirdLast === 'impact' && prev === 'period') return -10;
    if (pathname.includes('edit')) return -30;

    return 0;
  };

  const textColor = colorVariant === 'alt' ? 'white' : colors.titleText;

  return (
    <View style={Platform.OS === 'ios' ? { maxWidth: width - 60 } : { width: 'auto', paddingHorizontal: 10 }}>
      <Text
        fontWeight={fontWeight}
        style={[
          styles.label,
          {
            color: textColor,
            textAlign: 'center',
            alignSelf: 'center',
            ...(Platform.OS !== 'ios' && { marginLeft: getMarginLeft() })
          }
        ]}
        numberOfLines={1}>
        {label}
      </Text>
    </View>
  );
};

export default Title;

const styles = StyleSheet.create({
  label: {
    width: '100%',
    minWidth: 100,
    fontSize: 20,
    textAlign: 'center'
  }
});
